// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + (chunkId === 884 ? "admin" : chunkId) + "." + {"884":"11c60dbb","897":"c7d1b8c4"}[chunkId] + ".css";
};